export default __webpack_public_path__ + "static/media/30.e9be5af7.svg";